<template>
    <div class=" offersbycoupon">
       
                        
            <b-container class="text-center px-0">
                <div>
                    <VueSlickCarousel v-bind="settings">
                        <b-col class="relative" v-for="(data,index) in bannerItems" :key="index">
							 <div class="coupontop" v-if="data.category_title!='null' || data.category_title!=null">
                                <p class="mb-2 desctop" >{{data.category_title}}</p>
                               
                              </div>
							<b-link  @click.stop.prevent="copyTestingCode(index)">
							<input type="hidden" :id="'testing-code'+index" v-model="data.code" >
                             <!--<b-img-lazy v-bind="mainProps" :src="$root.MEDIAPATH+'banners/category/offers/Dresses.jpg'" fluid alt="Responsive image"></b-img-lazy> -->
                             <b-img-lazy v-bind="mainProps" :src="$root.MEDIAPATH+'images/logo_alluraa.png'" fluid alt="Responsive image" class="logoOffer"></b-img-lazy> 
							 <!-- <b-img-lazy v-bind="mainProps"  :src="$root.MEDIAPATH+'banners/category/offers/'+data.img" fluid ></b-img-lazy> -->
							  
							  
                              <div class="absolute">
                                <p class="mb-2 desc" ><span class="couponCod">{{data.code}}</span></p>
                                <b-button v-if="data.price_type==0" size="lg" rounded="top" class="offer-btn" >{{data.price}}% OFF</b-button>
                                <b-button  v-else size="lg" rounded="top" class="offer-btn" >{{$root.currency()+$root.tofixed(data.price)}}/- OFF</b-button>
                              </div>
							 </b-link>
                        </b-col>
                        
                    </VueSlickCarousel>
                </div>
            </b-container>
        
    </div>
</template>
<script>

import VueSlickCarousel from 'vue-slick-carousel'
  import 'vue-slick-carousel/dist/vue-slick-carousel.css'
  // optional style for arrows & dots
  import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'

export default {
    name: 'HeroCarouselj',
    components: {VueSlickCarousel},
	mounted(){
		this.initload();
		
	  
	  /*if(window.innerWidth < 700){
			this.columInarow  = 2;
			
		 }*/
	},
    data() {
        return {
			 mainProps: { class: 'm1', center: true,blankColor: '#fff',width:283,height:170},
            settings: {
                "arrows": true,
                "dotsClass": "slick-dots custom-dot-class",
                "edgeFriction": 0.35,
                "infinite": true,
                "autoplay": true,
                "speed": 500,
                "cssEase": "linear",
                "slidesToShow": 4,
                "slidesToScroll": 1,
                "responsive": [
							{
							  "breakpoint": 1024,
							  "settings": {
								"slidesToShow": 3,
								"slidesToScroll": 3,
								"infinite": true,
								"dots": true
							  }
							},
							{
							  "breakpoint": 600,
							  "settings": {
								"slidesToShow": 2,
								"slidesToScroll": 2,
								"initialSlide": 2
							  }
							},
							{
							  "breakpoint": 480,
							  "settings": {
								"slidesToShow": 1,
								"slidesToScroll": 1
							  }
							}
						  ]
            },
			bannerItems:[		 
			 {img:"Dresses.jpg",title:"Dresses",url:"/women-indian-wear",offer:'66'},
			 {img:"Kurti&Kurtas.jpg",title:"Kurti & Kurtas",url:"/kurtas-suits",offer:'58'},
			 {img:"T-Shirts.jpg",title:"T-Shirts",url:"/men-casual-shirts",offer:'76'},
			 {img:"Shirts.jpg",title:"Shirts",url:"/men-casual-shirts",offer:'30'},
			 {img:"Organic-Products.jpg",title:"Organic Products",url:"/organic",offer:'38'},
			 {img:"Cosmetic.jpg",title:"Cosmetics",url:"/cosmetics",offer:'48'},
			 {img:"SkinCare.jpg",title:"Skin Care",url:"/skin-care",offer:'38'},
			 {img:"MenShoes.jpg",title:"Men Shoes",url:"/men-footwear",offer:'74'},
			 {img:"WomenShoes.jpg",title:"Women Shoes",url:"/womens-footwear",offer:'10'},
			 {img:"Accessories.jpg",title:"Accessories",url:"/women-accessories",offer:'50'}
			 ],
			couponoffersurl: this.$root.WEBAPI+'couponapi/couponoffers',		
			toporders:[],
			
        }
    },
	methods: {
		initload(){
			var self = this;
			self.axios.post(self.couponoffersurl, {
				accesskey: self.$root.customer_info.access_key,
				/*category: this.$route.params.category,
				subcategory: categieyName,
				filter:self.filterQuery,
				page:self.nextPage*/
			}).then(function (response) {
				if(response.data.error == 0 || response.data.error == '0'){
					self.bannerItems=[];
					var topOffer =  response.data.result.topOffers;
					topOffer.forEach(item => {
						self.bannerItems.push(item);
					});
					
				}
			}).catch(function (error) {
				alert(error);
			});
		
		
		},
		copyTestingCode (idindex) {
			var self =this;
			console.log(self.referralCode);
			var textcodeId = '#testing-code'+idindex;
          let testingCodeToCopy = document.querySelector(textcodeId)
			testingCodeToCopy.setAttribute('type', 'text')   
          testingCodeToCopy.select();

          try {
            var successful = document.execCommand('copy');
            var msg = successful ? 'successful' : 'unsuccessful';
			var messLi= 'Coupon code was copied ' + msg;
			self.$bvToast.toast(messLi, {
					title: 'Unique Coupon code',
					toaster: 'b-toaster-bottom-right',
					autoHideDelay: 5000,
					variant: 'success',
					solid: true,
					appendToast: true
				});
			
          } catch (err) {
            alert('Oops, unable to copy');
          }

          /* unselect the range */
          testingCodeToCopy.setAttribute('type', 'hidden')
          window.getSelection().removeAllRanges()
        },
	},

}
</script>
<style  lang="scss">
.offersbycoupon{
    .relative {
        position:relative;
		/* background: #f2f2f2; */
		background: #683581;
		width: 95% !important;
		a{
			    text-decoration: none;
			&:hover{
			text-decoration: none;
			}
		}
		
    }
    .absolute {
       /* position: absolute;*/
        bottom: 0;
        display: flex;
        align-items: center;
        flex-direction: column;
        width: 100%;
        left: 0;
        justify-content: center;
        overflow: hidden;
		margin-top: -49px;
		
    }
	.coupontop {
       position: absolute;
        top: 5px;
        display: flex;
        align-items: center;
        flex-direction: column;
        width: 100%;
        left: 0;
        justify-content: center;
        overflow: hidden;
		.desctop  {
			color: white;
			z-index: 0;
			font-size:16px;
		}
		
    }
    .offer-btn {
		width:85%;
        background: #f2f2f2;
        border-radius: 0 !important;
		border:0px;
        border-radius: 1rem 1rem 0rem 0rem !important;
        border-bottom-color: transparent !important;
        box-shadow: 0px 3px 55px rgba(0,0,0,0.5);
        color: black;
		&:hover {
			  background-color: #7954A1;
			  color:#fff;
			  text-decoration: none;
			}
    }
	  
    .desc  {
        color: white;
        z-index: 0;
		.couponCod{
			 border: 1px dashed  #fff;
			/*color: #d9007e; */
			font-size: 20px;
			font-weight: 600;
			padding: 2px 5px;
		}
		
    }
		.slick{
		&-prev {
		  /*left: 3% !important;*/
		  top: 45% !important;
		 
			width: 25px;
			height: 25px;
			background-color: #FFF;
			box-shadow: #bbb 0px 0px 6px;
			border-radius: 100px;
			
		  &:before{ 					
				content: 'prev'; 
				font-family: swiper-icons;
				color: #683581;
				font-size: 15px;
				font-weight: 700;
			}
			
		  
		}
		&-next {
		 /* right: 3% !important;*/
			top: 45% !important;
			
		  	width: 25px;
			height: 25px;
			background-color: #FFF;
			box-shadow: #bbb 0px 0px 6px;
			border-radius: 100px;

			&:before{ 	
					content: 'next'; 
					font-family: swiper-icons;
					color: #683581;
					font-size: 15px;
					font-weight: 700;
				}
			
		} 
	
	}
	
		.logoOffer{
			padding:5px;
			
		}
	
	}
</style>